import { Link } from 'react-router-dom';
import { Trophy, ArrowRight } from 'lucide-react';

export const ChallengesTeaserSection = ({ challenges }) => {
  if (!challenges || challenges.length === 0) return null;

  return (
    <section className="py-16 px-6 border-y border-white/10" data-testid="challenges-teaser-section">
      <div className="max-w-5xl mx-auto">
        <div className="text-center mb-10">
          <p className="text-xs font-mono uppercase tracking-[0.3em] text-primary mb-3">Startup Challenge</p>
          <h2 className="font-heading text-3xl md:text-4xl font-bold">Le challenge dell'evento</h2>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
          {challenges.map(ch => {
            const totalJudges = (ch.judges || []).length;
            return (
              <Link
                key={ch.id}
                to={`/challenges/${ch.slug || ch.id}`}
                className="group block glass rounded-2xl p-6 md:p-8 hover:border-primary/50 transition-all"
                data-testid={`challenge-teaser-${ch.id}`}
              >
                <div className="flex items-start gap-5">
                  <div className="w-14 h-14 rounded-xl bg-primary/15 flex items-center justify-center flex-shrink-0">
                    <Trophy size={26} className="text-primary" />
                  </div>
                  <div className="flex-1 min-w-0">
                    <h3 className="font-heading text-xl md:text-2xl font-bold leading-tight mb-2">{ch.title}</h3>
                    {totalJudges > 0 && (
                      <p className="text-xs font-mono uppercase tracking-[0.2em] text-muted-foreground">
                        {totalJudges} {totalJudges === 1 ? 'giurato' : 'giurati'}
                      </p>
                    )}
                  </div>
                  <ArrowRight size={20} className="text-muted-foreground group-hover:text-primary group-hover:translate-x-1 transition-all flex-shrink-0 mt-1" />
                </div>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
};
